import { SystemAuthorizations } from 'shell/authorizations/system';
import { PublishedConsumedEventClient } from './types';
import { HeadCell } from 'shell/components/shared/table/types';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.EventoQuery],
});

export const headCells: HeadCell<
  PublishedConsumedEventClient,
  keyof PublishedConsumedEventClient
>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'dataTimeConsummation',
    label: 'Data ora consumazione',
  },
  {
    id: 'typeDestination',
    label: 'Tipo Destinazione',
  },
  {
    id: 'descriptionTypeDestination',
    label: 'Descrizione Tipo Destinazione',
  },
  {
    id: 'subscriber',
    label: 'Sottoscrittore',
  },
  {
    id: 'descriptionSubscriber',
    label: 'Descrizione Sottoscrittore',
  },
  {
    id: 'progressive',
    label: 'Progr.',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: '',
  },
];
